/**
 * Forms module for handling form input interactions
 * @module forms
 */

/**
 * Initialize form inputs with custom label behavior
 */
function initializeFormInputs() {

	const inputs = document.querySelectorAll( '.wpforms-field input' );

	inputs.forEach( input => {

		const fieldContainer = input.closest( '.wpforms-field' );
		const label = fieldContainer.querySelector( '.wpforms-field-label' );

		// Change label position
		label.style.position = 'absolute';
		label.style.right = '0.75rem';
		label.style.top = '1.75rem';
		label.style.pointerEvents = 'none';
		label.classList.add( 'wpforms-field-label--custom' );

		// Optional: hide the label when the text is too long
		input.addEventListener( 'input', () => {

			const inputWidth = input.offsetWidth;
			const textWidth = getTextWidth( input.value, getComputedStyle( input ).font );

			if ( textWidth > inputWidth - label.offsetWidth - 40 ) {

				label.style.opacity = '0';

			} else {

				label.style.opacity = '1';

			}

		} );

	} );

}

/**
 * Function to measure text width
 * @param {string} text - The text to measure
 * @param {string} font - Font specification
 * @return {number} Width of the text
 */
function getTextWidth( text, font ) {

	const canvas = getTextWidth.canvas || ( getTextWidth.canvas = document.createElement( 'canvas' ) );
	const context = canvas.getContext( '2d' );
	context.font = font;
	const metrics = context.measureText( text );
	return metrics.width;

}

/**
 * Initialize the module
 */
function init() {

	initializeFormInputs();

}

export default {
	init,
	initializeFormInputs
};
